import { render, staticRenderFns } from "./ViewComment.vue?vue&type=template&id=700c4a1e"
import script from "./ViewComment.vue?vue&type=script&lang=js"
export * from "./ViewComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports